module.exports = __webpack_public_path__ + "static/media/br.d5fc3717.svg";